<script lang="ts">
    import CalculatorPercentChanceResult from "./components/CalculatorPercentChanceResult.svelte";
    import CalculatorBox from "./components/CalculatorBox.svelte";
    import CalculatorNumberInput from "./components/CalculatorNumberInput.svelte";
    import CalculatorSeparator from "./components/CalculatorSeparator.svelte";
    import CalculatorSection from "./components/CalculatorSection.svelte";

    function calculateSkillCheckProbability(
        diceSides: number,
        dc: number,
        modifier: number,
    ): number {
        return (diceSides - dc + modifier) / diceSides;
    }

    let ac;
    let modifier;

    let percentSuccess = null;
    $: if (ac && modifier) {
        const probability = calculateSkillCheckProbability(20, ac, modifier);
        percentSuccess = probability * 100;
    } else {
        percentSuccess = null;
    }
</script>

<CalculatorBox>
    <div>
        <CalculatorSection>
            <p class="font-size-1-2-rem">Given an DC of</p>
            <CalculatorNumberInput bind:number={ac} placeholder="DC" />
            <p class="font-size-1-2-rem">and a modifier of</p>
            <CalculatorNumberInput
                bind:number={modifier}
                placeholder="Skill / Ability Modifier"
            />
        </CalculatorSection>
        <CalculatorSeparator />
        <CalculatorSection>
            <p class="font-size-1-2-rem">Passing the check is...</p>
        </CalculatorSection>
        <CalculatorSection>
            <CalculatorPercentChanceResult {percentSuccess} />
        </CalculatorSection>
    </div>
</CalculatorBox>
